module.exports = __webpack_public_path__ + "media/images/walkthrough-6ee384c15e953dc19746e7eafadb7cd7.gif";